<div class="app-shell" [class.authenticated]="showHeader()">
  @if (showHeader()) {
    <app-header />
  }
  <router-outlet />
  <app-toast />
</div>
